import styled from "styled-components"
import { theme } from "../../../util/styles/theme"
import { BaseInput } from "../base-input/BaseInput"

export const TextInput = styled(BaseInput)`
  ${theme.textStyle("default", "medium", "normal")}
  height: 3rem;
`
